import {
  IngestionStream,
  Ingestion,
  IngestionQuery,
  IngestionLogQuery,
  IngestionStreamLogCount,
  DocumentQuery,
  DownloadQuery
} from '../model/ingestion-stream';
import { Observable } from 'rxjs';

export abstract class IngestionApiService {
  public abstract getAllIngestionStreams(
    ingestionQuery: IngestionQuery
  ): Observable<{ items: Array<IngestionStream>; paginationCursor?: any }>;
  public abstract getIngestionByStreamUri(ingestionLogQuery: IngestionLogQuery): Observable<{
    items: Array<Ingestion>;
    paginationCursor?: any;
    total?: number;
  }>;
  public abstract getIngestionStreamLogCount(
    aggregationType: string,
    ingestionLogQuery: IngestionLogQuery
  ): Observable<IngestionStreamLogCount>;
  public abstract getDocumentsCount(aggregationType: string, documentQuery: DocumentQuery): Observable<IngestionStreamLogCount>;

  public abstract getFileDownloadURL(query: DownloadQuery): string;
  public abstract getSourceDocumentCount(query): any;
  public abstract updateIngestionStream(query, uri: string): Observable<IngestionStream>;
}
